export default {
  machines: [],
  basicData: null,
  orderList: [],
  deliveryTypes: null,
  onHoldDeliveryDetails: null,
  priceList: [],
  freeContingent: false,
  machineId: null,
  referenceNumber: null,
  machineNumber: null
};
